import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SchemaReview from '../components/SchemaReview';

const SchemaReviewPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" component="h1">
            Schema Review
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => navigate(-1)}
          >
            Back to Appointments
          </Button>
        </Box>
        
        <Typography variant="body1" paragraph>
          Please review the schema design below. This is a preview of the data structure 
          before we apply the database migration.
        </Typography>
        
        <SchemaReview />
        
        <Box mt={4} p={3} bgcolor="#f8f9fa" borderRadius={1}>
          <Typography variant="h6" gutterBottom>
            Next Steps:
          </Typography>
          <ol>
            <li>Review the schema design above</li>
            <li>Check the sample data for each field</li>
            <li>Make any necessary adjustments to the schema</li>
            <li>Once approved, we'll run the database migration</li>
          </ol>
        </Box>
      </Box>
    </Container>
  );
};

export default SchemaReviewPage;
